"use strict";
/*******************************************************************************

    Contains a class to calculate the fees used to store the data

    Copyright:
        Copyright (c) 2020-2021 BOSAGORA Foundation
        All rights reserved.

    License:
        MIT License. See LICENSE for details.

*******************************************************************************/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TxPayloadFee = void 0;
var Amount_1 = require("../common/Amount");
var jsbi_1 = __importDefault(require("jsbi"));
/**
 * A class for calculating the fee of transaction data payload
 */
var TxPayloadFee = /** @class */ (function () {
    function TxPayloadFee() {
    }
    /**
     * Calculates the fee of data payloads
     * @data_size The size of the data
     */
    TxPayloadFee.getFee = function (data_size) {
        if (data_size < 0)
            throw new Error("Data size cannot be negative.");
        if (data_size > TxPayloadFee.TxPayloadMaxSize)
            throw new Error("Data size cannot be greater than maximum.");
        var decimal = 100;
        return jsbi_1.default.BigInt((Math.round((Math.exp(data_size / TxPayloadFee.TxPayloadFeeFactor) - 1.0) * decimal) * 10000000) / decimal);
    };
    /**
     * Calculates the fee of data payloads
     * @data_size The size of the data
     */
    TxPayloadFee.getFeeAmount = function (data_size) {
        return Amount_1.Amount.make(TxPayloadFee.getFee(data_size));
    };
    /**
     * The address of commons budget
     */
    TxPayloadFee.CommonsBudgetAddress = "boa1xqcmmns5swnm03zay5wjplgupe65uw4w0dafzsdsqtwq6gv3h3lcz24a8ch";
    /**
     * The maximum size of data payload
     */
    TxPayloadFee.TxPayloadMaxSize = 1024;
    /**
     * The factor to calculate for the fee of data payload
     */
    TxPayloadFee.TxPayloadFeeFactor = 200;
    return TxPayloadFee;
}());
exports.TxPayloadFee = TxPayloadFee;
//# sourceMappingURL=TxPayloadFee.js.map